(function(angular){
    'use strict';

    angular.module('onvio.setup.migrations').controller('onvio.setup.migrations.fileCabinet.DrawerSelectionController', drawerSelectionCtrl);
    drawerSelectionCtrl.$inject = ['$scope', '$q', '$translate', '$stateParams', '$uibModal', '$compile', '$document',
                                   '$location', '$http', '$window', '$timeout', '$interval', '$bentoBusyLoader', 'FlexGridSetUpFactory',
                                   'migrationService', 'bmpConfirmationDialog'];

    function drawerSelectionCtrl($scope, $q, $translate, $stateParams, $uibModal, $compile, $document, $location,
                                 $http, $window, $timeout, $interval, $bentoBusyLoader, flexGridSetUpFactory,
                                 migrationService, bmpConfirmationDialog) {
        /*jshint validthis:true */
        var vm = this;
        vm.gridDataTwo = [];                   // it's not updated by bento-flexgrid-transferbox, bug?
        vm.params = {
            orderBy: 'id',
            search: '',
            searchBy: '',
            filter: '',
            startIndex: 0,
            itemsPerPage: 25
        };
        //vm.companyId = $scope.migrationConfig.companyId;
        //vm.migrationProductId = $scope.currentProduct.migrationProductId;

        vm.config = {
            availableTitle: $translate.instant('Onvio.Migrations.DrawerSelect.AvailableDrawers'),
            selectedTitle: $translate.instant('Onvio.Migrations.DrawerSelect.DrawersAdded'),
            height: 500,
            transferInfoText: $translate.instant('Onvio.Bento.TransferBox.CHECKED'),
            transferBtnText: $translate.instant('Onvio.Migrations.Label.Migrate'),
            paginationInfoText: $translate.instant('Onvio.Bento.Pagination.INFO_TEXT'),
            paginationInfoPageText: $translate.instant('Onvio.Bento.Pagination.INFO_PAGE_TEXT'),
            boxOneInfoShown: true,
            boxTwoInfoShown: true,
            desktopMode: true,
            filtersShown: true
        };
        vm.config.columnDefinitions = [{
            binding: 'itemIdShort',
            header: $translate.instant('Onvio.Migrations.DrawerSelect.DrawerId'),
            filter: {
                type: 'input'
            }
        }, {
            binding: 'name',
            header: $translate.instant('Onvio.Migrations.DrawerSelect.Name'),
            filter: {
                type: 'input'
            }
        }, {
            binding: 'edited',
            header: $translate.instant('Onvio.Migrations.DrawerSelect.LastEdited'),
            filter: {
                type: 'input'
            }
        }, {
            binding: 'uploadedText',
            header: $translate.instant('Onvio.Migrations.DrawerSelect.Uploaded'),
            filter: {
                type: 'select',
                options: [{
                    name: $translate.instant('Onvio.Migrations.Uploaded.NotYet'),
                    value: ' '
                }, {
                    name: $translate.instant('Onvio.Migrations.Uploaded.Yes'),
                    value: 'Yes'
                }, {
                    name: $translate.instant('Onvio.Migrations.Uploaded.All'),
                    value: null
                }]
            }
        }];

        vm.toggleAll = function toggleAll(box) {
            if (vm.transferbox) {
                vm.transferbox.toggleAll(box);
            }
        };

        vm.onTransfer = function onTransfer(gridDataOne, gridDataTwo) {
            // work-around to record the selected drawers
            $scope.selectedDrawerList.splice(0,  $scope.selectedDrawerList.length);
            gridDataTwo.forEach( function(item) {
                $scope.selectedDrawerList.push(item);
            });
            vm.gridDataTwo = gridDataTwo;
        };

        vm.loadAvailableDrawers = function() {
            $scope.busyLoading = true;
            $scope.loadingFailed = false;
            $scope.availableDrawerList.splice(0, $scope.availableDrawerList.length);
            vm.gridDataTwo.splice(0, vm.gridDataTwo.length);
            $scope.drawerListLoaded = false;
            $scope.drawerListLoadedPath = $scope.pathToData;
            migrationService.getMigrationProductSets($scope.migrationConfig.companyId, $scope.currentProduct.migrationProductId, $scope.pathToData)
            .then( function(resp) {
                resp.items.forEach( function(itemSet) {
                    var props = vm.getItemProps(itemSet.item);
                    var item = angular.extend(props, itemSet);
                    if (item.uploaded) {
                        item.uploadedText = 'Yes';
                    } else {
                        item.uploadedText = ' ';
                    }
                    item.itemIdShort = item.itemId;
                    var pos = item.itemId.search('::');
                    if (pos === 32 && item.itemId.length >= 34) {
                        // remove the data path hash
                        item.itemIdShort = item.itemId.substring(34);
                    }
                    $scope.availableDrawerList.push(item);
                });
                $scope.drawerListLoaded = true;
            }, function() {
                $scope.loadingFailed = true;
            })
            .finally(function() {
                $scope.busyLoading = false;
            });
        };

        vm.getItemProps = function(itemMeta) {
            if ( angular.isUndefined(itemMeta) ) {
                return {};
            }
            var itemJson = JSON.parse(itemMeta);
            var props = {
                name: itemJson.name,
                edited: migrationService.getDateStringShort(itemJson.edited)
            };
            return props;
        };

        $scope.isPreviousUploadingDead = false;
        $scope.isCureentUploadingDead = false;
        vm.onDrawerSelectionVisible = function() {
            if ($scope.loadItemSetBusy) {
                return;
            }
            // update currentItemSetInfo
            //vm.loadItemSetRefreshInfo();

            /*
            $scope.isUploadingTimeout = $scope.checkUploadingTimeout($scope.currentItemSetInfo);
            if (!$scope.isUploadingTimeout) {
                $scope.loadItemSetAlerts = [];
                var alertType = 'warning';
                var alertMsg = 'Your previous uploading process may have stopped unexpectedly. You may need to reload your drawers again.';
                $scope.loadItemSetAlerts.push({
                    type: alertType,
                    msg: alertMsg,
                    closeable: true
                });
            }
            */
            $scope.isPreviousUploadingDead = $scope.isUploadingDead($scope.itemSetInfo);
            $scope.isCureentUploadingDead = $scope.isUploadingDead($scope.currentItemSetInfo);
        };

        $scope.$on('load-drawers', function() {
            vm.loadAvailableDrawers();
        });

        $scope.$on('drawer-selection-visible', function() {
            vm.onDrawerSelectionVisible();
        });

        $scope.loadItemSet = function() {
            bmpConfirmationDialog.open({
                titleText: 'Reload Items Set',
                bodyText: 'It will take a while to reload all items. Do you still want to continue?',
                confirmText: $translate.instant('Onvio.Setup.Common.Buttons.Yes'),
                cancelText: $translate.instant('Onvio.Setup.Common.Buttons.No')
            }).then(function() {
                vm.startLoadItemSet();
            });
        };

        $scope.loadItemSetBusy = false;
        $scope.loadItemSetFailed = false;
        $scope.loadItemSetAlerts = [];
        $scope.currentItemSetInfo = {};
        $scope.checkUploadingStateTime = Date.now();
        $scope.uploadingStatusClass = 'label label-info';
        $scope.isUploadingTimeout = false;
        vm.loadItemSetStartTime = new Date();
        vm.startLoadItemSet = function() {
            $scope.loadItemSetBusy = true;
            $scope.loadItemSetFailed = false;
            $scope.loadItemSetAlerts = [];
            $scope.uploadingStatusClass = 'label label-info';
            $scope.isUploadingTimeout = false;
            //vm.clearTransferBox();
            vm.loadItemSetStartTime = Date.now();
            vm.utilityLoadItemSet();
            vm.loadItemSetChecking();
            vm.startTimeoutCounter();
        };

        vm.clearTransferBox = function() {
            $scope.availableDrawerList.splice(0, $scope.availableDrawerList.length);
            vm.gridDataTwo.splice(0, vm.gridDataTwo.length);
            $scope.selectedDrawerList.splice(0,  $scope.selectedDrawerList.length);
            $scope.selectedGridDataTwo.splice(0,  $scope.selectedGridDataTwo.length);
        };

        vm.utilityWin = null;
        vm.utilityLoadItemSet = function() {
            var url = $scope.migrationApps.utilityUrl + 'action=load-items-set&migrationProductId=' + $scope.currentProduct.migrationProductId + '&' +
                      'dataPath=' + encodeURI($scope.pathToData);
            vm.utilityWin = $window.open(url, '_blank');
            //vm.utilityWin.focus();
            $timeout(function() {
                vm.utilityWin.close();
            }, $scope.migrationApps.utilityWinTimeout);
        };

        vm.loadItemSetChecking = function() {
            var dt = Date.now() - vm.loadItemSetStartTime;
            if ((dt > $scope.migrationApps.loadItemSetTimeout) && (!vm.isUploadingStarted())) {
                $scope.loadItemSetBusy = false;
                $scope.loadItemSetFailed = true;
                vm.processTimeoutAlert ();
                return;
            }

            // not checking in background if loading has started and this screen is not visible
            if (!vm.isUploadingStarted() || $scope.isDrawerSelectionVisible()) {
                vm.loadItemSetRefreshInfo();
            }
            if (vm.isItemSetRefreshed()) {
                $scope.uploadingStatusClass = 'label label-success';
                vm.loadAvailableDrawers();
                angular.extend($scope.itemSetInfo, $scope.currentItemSetInfo);
                return;
            } else {
                $timeout(vm.loadItemSetChecking, $scope.migrationApps.loadItemSetPoolingGap);
            }
        };

        vm.processTimeoutAlert = function() {
            var alertType;
            var alertMsg;
            if ( !vm.isUploadingStarted() ) {
                alertType = 'danger';
                alertMsg = 'The uploading process has not been started. Please make sure you have installed the desktop utility';
            } else {
                alertType = 'info';
                alertMsg = 'Your uploading process is still running. Please wait until it is done.';
                $scope.isUploadingTimeout = true;
            }
            $scope.loadItemSetAlerts.push({
                type: alertType,
                msg: alertMsg,
                closeable: true
            });
        };

        $scope.loadingItemSetRefreshFailed = false;
        $scope.isCurrentUploadingContinue = false;
        vm.loadItemSetRefreshInfo = function() {
            $scope.loadingItemSetRefreshFailed = false;
            migrationService.getItemSetRefreshInfo($scope.migrationConfig.companyId, $scope.currentProduct.migrationProductId)
            .then( function(resp) {
                $scope.checkUploadingStateTime = new Date();
                var productMeta = resp.productMeta;
                $scope.setRefreshInfoOnProduct(productMeta, $scope.currentItemSetInfo);
                $scope.isCurrentUploadingContinue = $scope.isUploadingContinue($scope.currentItemSetInfo);
            }, function() {
                $scope.loadingItemSetRefreshFailed = true;
            });
        };

        vm.isItemSetRefreshed = function() {
            /*
            if (angular.isUndefined($scope.itemSetInfo.itemSetRefreshDate)) {
                // items set have never been installed
                if (angular.isDefined($scope.currentItemSetInfo.itemSetUploadState) &&
                    $scope.currentItemSetInfo.itemSetUploadState === 'refreshed') {
                    return true;
                } else {
                    return false;
                }
            } else {
                // items set have been installed before
                if ( angular.isUndefined($scope.currentItemSetInfo.itemSetUploadState) ) {
                    return false;
                }
                if ( $scope.currentItemSetInfo.itemSetUploadState !== 'refreshed' ) {
                    return false;
                }
                // 'refreshed' state, but need to check if it's from re-load
                if ( angular.isUndefined($scope.currentItemSetInfo.itemSetRefreshDate) ) {
                    return false;
                }
                var oldDate = new Date($scope.itemSetInfo.itemSetRefreshDate);
                var newDate = new Date($scope.currentItemSetInfo.itemSetRefreshDate);
                var dt = newDate.getTime() - oldDate.getTime();
                if( dt > 1 ) {
                    return true;
                } else {
                    return false;
                }
            }
            */
            if ( !vm.isUploadingStarted() ) {
                return false;
            }
            if (angular.isDefined($scope.currentItemSetInfo.itemSetUploadState) &&
                $scope.currentItemSetInfo.itemSetUploadState === 'refreshed') {
                return true;
            }
            return false;
        };

        vm.isUploadingStarted = function() {
            if (angular.isUndefined($scope.currentItemSetInfo.itemSetUploadTime)) {
               return false;
            }
            // if previous itemSetUploadTime does not exist, but the current one has values
            if (angular.isUndefined($scope.itemSetInfo.itemSetUploadTime)) {
               return true;
            }
            // case if both dates exist
            var oldDate = new Date($scope.itemSetInfo.itemUploadTime);
            var newDate = new Date($scope.currentItemSetInfo.itemUploadTime);
            var dt = newDate.getTime() - oldDate.getTime();
            if (dt > 1) {
               return true;
            }
            return false;
        };

        $scope.currentUploadingStatus = function() {
            if ( !vm.isUploadingStarted() ) {
                $scope.uploadingStatusClass = 'label label-warning';
                return 'Uploading not started yet';
            }
            $scope.uploadingStatusClass = 'label label-info';
            return $scope.currentItemSetInfo.itemSetUploadState;
        };

        $scope.currentUploadingCount = function() {
            if ( !vm.isUploadingStarted() ) {
                return 0;
            }
            return $scope.currentItemSetInfo.itemSetTotalCount;
        };

        $scope.latestUploadingTime = function() {
            if ( !vm.isUploadingStarted() ) {
                return '';
            }
            return $scope.currentItemSetInfo.itemSetUploadTime;
        };

        $scope.getCheckUploadingStateTime = function() {
            return $scope.checkUploadingStateTime.toLocaleTimeString();
        };

        vm.getTimeoutLeft = function() {
            var dt = Date.now() - vm.loadItemSetStartTime;
            var leftDt = $scope.migrationApps.loadItemSetTimeout - dt;
            if (leftDt < 0) {
                leftDt = 0;
            }
            var mm = Math.floor(leftDt / (1000 * 60));
            var ss = Math.floor((leftDt - mm * 60000) / 1000);
            var str;
            if (mm === 0) {
                str = '00';
            } else if (mm < 10) {
                str = '0' + mm;
            } else {
                str = mm;
            }
            str = str + ':';
            if (ss <= 0) {
                str = str + '00';
            } else if (ss < 10) {
                str = str + '0' + ss;
            } else {
                str = str + ss;
            }
            return str;
        };

        $scope.timeoutCounterText = null;
        vm.timeoutCounter = undefined;
        vm.intervalTotalCount = $scope.migrationApps.loadItemSetTimeout / 1000;
        vm.startTimeoutCounter = function() {
            if (angular.isDefined(vm.timeoutCounter)) {
                return;
            }
            $scope.timeoutCounterText = null;
            vm.timeoutCounter = $interval(function() {
                $scope.timeoutCounterText = vm.getTimeoutLeft();
                if (!$scope.loadItemSetBusy) {
                    vm.stopTimeoutCounter();
                }
            }, 1000, vm.intervalTotalCount);
        };

        vm.stopTimeoutCounter = function() {
            if (angular.isDefined(vm.timeoutCounter)) {
                $interval.cancel(vm.timeoutCounter);
                vm.timeoutCounter = undefined;
            }
        };

        $scope.$on('$destroy', function() {
            vm.stopTimeoutCounter();
        });

        $scope.refreshView = function() {
            vm.clearTransferBox();
            vm.loadAvailableDrawers();
            vm.loadItemSetRefreshInfo();
            $scope.isCurrentUploadingContinue = $scope.isUploadingContinue($scope.currentItemSetInfo);
        };

        $scope.loadItemsButtonText = function() {
            if ($scope.showAvailableDrawersNote()) {
                return 'Refresh Drawers';
            }
            return 'Upload Drawers';
        };

        $scope.hasAvailableDrawers = function() {
            if ($scope.availableDrawerList.length > 0) {
                return true;
            }
            return false;
        };

        $scope.showUploadingContinue = function() {
            if ($scope.loadItemSetBusy) {
                return false;
            }
            if ($scope.isPreviousUploadingContinue || $scope.isCurrentUploadingContinue) {
                return true;
            }
            return false;
        };

        $scope.showUploadingStatus = function() {
            if ($scope.loadItemSetBusy || $scope.showUploadingContinue()) {
                return true;
            }
            return false;
        };

        $scope.showAvailableDrawersNote = function() {
            if ($scope.availableDrawerList.length > 0 && !$scope.busyLoading) {
                return true;
            }
            return false;
        };

        $scope.showEmptyDrawersNote = function() {
            if ($scope.availableDrawerList.length === 0 && !$scope.busyLoading) {
                return true;
            }
            return false;
        };
    }

})(window.angular);
